import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import { Button, Checkbox, Icon, Input, message, Modal } from "antd";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import ListItem from "./Components/ListItem";
import MembersList from "../../../MembersList";

import { curSessionIdAtom } from "../../../../store";
import { useAtom } from "jotai";

import {
    CustomEmpty,
    closeSessionBatch,
    errorMessage,
    ResultMessage,
    setHasRead,
    useModalHandler
} from "../../../../polyfills";
import useUpdateSession from "../../../../Utils/useUpdateSession";
import useFilterSessionList from "../../../../Utils/useFilterSessionList";

const { Search } = Input;

export default function ContactsList() {
    const membersModal = useModalHandler();

    const { sessionList, setSearchText } = useFilterSessionList();

    const sessionManager = useUpdateSession();
    const [curSessionId, setCurSessionId] = useAtom(curSessionIdAtom);

    //选择 checkbox
    const [select, setSelect] = useState<CheckboxValueType[]>([]);

    const onCheckAllChange = (e: CheckboxChangeEvent) => {
        const plainOptions = sessionList?.map(item => item.guid);
        setSelect(e.target.checked ? plainOptions || [] : []);
    };

    //全选
    const checkAll = useMemo(() => {
        return select.length === sessionList?.length && select.length > 0;
    }, [select]);

    function handleReadStatus() {
        if (select.length === 0) {
            Modal.confirm({
                title: `尚未选择要标记为已读的消息，请勾选要标记为已读的消息后点击“全部标记已读”按钮。`
            });
        } else {
            Modal.confirm({
                content: "消息被标记为已读后将无法恢复，确定执行？",
                onOk: async () => {
                    localStorage.setItem("unreadList", JSON.stringify([]));
                    try {
                        await setHasRead(select);
                        setSelect([]);

                        select.forEach(sessionId =>
                            sessionManager.markSessionRead(sessionId as string)
                        );

                        message.success("执行成功");
                    } catch (e) {
                        ResultMessage.error(errorMessage(e));
                    }
                }
            });
        }
    }

    function handleDelete() {
        if (select.length === 0) {
            Modal.confirm({
                title: `尚未选择要移除的消息，请勾选要移除的消息后点击“批量移除”按钮。`
            });
        } else {
            Modal.confirm({
                content: "消息被移除后，消息记录仍保留，确定执行？",
                onOk: async () => {
                    try {
                        await closeSessionBatch(select);
                        setSelect([]);
                        sessionManager.removeSession(select as string[]);
                        message.success("执行成功");
                    } catch (e) {
                        ResultMessage.error(errorMessage(e));
                    }
                }
            });
        }
    }

    return (
        <div className={style.root}>
            <div className={style.header}>联系人列表</div>

            <div className={style.searchWrapper}>
                <Search
                    maxLength={200}
                    allowClear
                    className={style.search}
                    placeholder="请输入联系人姓名或私信关键字"
                    onSearch={value => setSearchText(value)}
                />
                <img
                    src={require("./img/icon.png")}
                    alt=""
                    onClick={membersModal.open}
                />
            </div>

            <div className={style.tools}>
                <dl className={style.dl}>
                    <dt className={style.dt}>
                        <Checkbox
                            onChange={onCheckAllChange}
                            indeterminate={select.length > 0 && !checkAll}
                            checked={checkAll}
                        />
                    </dt>
                    <dd className={style.dd}>全选</dd>
                </dl>

                <Button type="link" onClick={handleDelete}>
                    <Icon type="delete" />
                    批量移除
                </Button>

                <Button type="link" onClick={handleReadStatus}>
                    <img
                        src={require("./img/clear.png")}
                        className={style.clearIcon}
                    />
                    全部标记已读
                </Button>
            </div>

            <Checkbox.Group
                className={style.list}
                value={select}
                onChange={setSelect}>
                {sessionList.map(item => (
                    <dl key={item.guid} className={style.dl}>
                        <dt className={style.dt}>
                            <Checkbox value={item.guid} />
                        </dt>
                        <dd className={style.dd}>
                            <ListItem
                                item={item}
                                active={item.guid === curSessionId}
                                changeCurrentChat={() =>
                                    setCurSessionId(item.guid)
                                }
                            />
                        </dd>
                    </dl>
                ))}

                {sessionList.length === 0 && (
                    <CustomEmpty
                        description="暂无聊天"
                        style={{ padding: "100px 0" }}
                    />
                )}
            </Checkbox.Group>

            <MembersList
                visible={membersModal.visible}
                onCancel={membersModal.close}
                onSuccess={membersModal.close}
            />
        </div>
    );
}
